module.exports = __webpack_public_path__ + "static/img/detailTitle-zcdx.8fa9646.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle-zcdx.png
// module id = 826
// module chunks = 0